module.exports = __webpack_public_path__ + "img/sub-cat-prof.7e3b42de.svg";